import React from 'react';

/**
 * OffersError — error state with retry.
 */
export default function OffersError({ error, onRetry }) {
  const message =
    typeof error === 'string'
      ? error
      : error?.message || 'Something went wrong loading offers.';
  return (
    <div
      role="alert"
      className="offers-error"
      style={{
        padding: 'var(--space-5)',
        background: 'var(--color-error-subtle)',
        border: '1px solid var(--color-error)',
        borderRadius: 'var(--radius-lg)',
        color: 'var(--color-text-primary)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-3)',
        alignItems: 'flex-start',
      }}
    >
      <strong style={{ color: 'var(--color-error)' }}>Could not load offers</strong>
      <span>{message}</span>
      {typeof onRetry === 'function' ? (
        <button type="button" className="btn btn-secondary" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}
